module.exports = __webpack_public_path__ + "src/assets/img/share/bgs/conscientiousness/012c2c7999cc57b0c384f956e6287b11.png";